module.exports = __webpack_public_path__ + "static/Law of Intellectual Property Law -31be3f94794d572abb9c19707ef829b8.jpg";